import { z } from "zod";

import { i18n } from "@libs/i18n";
import {
  publicCourseStatusEnumSchema,
  rowAchievementsTypeSchema,
  rowCoursesAchievementsTypeSchema,
  rowCoursesTypeSchema,
  updateCoursesTypeSchema,
} from "@libs/schemas";

import { campusSchema } from "./campus";
import { lessonSchema } from "./lesson";

export const courseSchema = rowCoursesTypeSchema.merge(
  z.object({
    campuses: z
      .array(
        campusSchema.pick({
          id: true,
          name: true,
          province: true,
        }),
      )
      .optional()
      .default([])
      .catch([]),
    lessons: z
      .array(
        lessonSchema
          .pick({
            id: true,
            name: true,
            module: true,
            is_attendance_required: true,
            activities: true,
          })
          .partial({
            module: true,
            is_attendance_required: true,
          }),
      )
      .optional()
      .catch([]),
    achievements: z
      .array(
        rowAchievementsTypeSchema
          .pick({
            id: true,
            name: true,
          })
          .merge(
            rowCoursesAchievementsTypeSchema.pick({
              weight: true,
            }),
          ),
      )
      .optional()
      .catch([]),
  }),
);
export type CourseType = z.infer<typeof courseSchema>;

export const updateCourseFormSchema = updateCoursesTypeSchema.omit({
  id: true,
  created_at: true,
  updated_at: true,
  full_text_search: true,
});
export type UpdateCourseFormType = z.infer<typeof updateCourseFormSchema>;

const courseFilterSchema = z.object({
  search: z.string().default("").catch(""),
  campusIds: z.array(z.string().uuid()).default([]).catch([]).optional(),
  isActiveOnly: z.boolean().optional(),
});
export type CourseFilterType = z.infer<typeof courseFilterSchema>;

export const courseSearchParamsSchema = courseFilterSchema.extend({
  id: z.string().uuid().optional().catch(""),
});

export type CourseStatusType = z.infer<typeof publicCourseStatusEnumSchema>;
export const courseStatusSchema = z.enum(["ACTIVE", "INACTIVE"]);
export const CourseStatus = courseStatusSchema.enum;

export const courseStatusOptions = courseStatusSchema.options.map(status => ({
  value: status,
  label:
    status === "ACTIVE" ? i18n.t("common:active") : i18n.t("common:inactive"),
}));
